import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class EmployeeCountColumn extends Column {
    title = 'company.positions.employeeCountColumn';
    property = 'employeeCount';
    type: CellDisplay = CellDisplay.string;
}
